import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';

type GPTModalStoreType = {
  gptModal: {
    id: string;
    name: string;
  } | null;
  setGPTModal: (id: string, name: string) => void;
  removeGPTModal: () => void;
};

const store = (set) => ({
  gptModal: null,

  setGPTModal(id: string, name: string) {
    set({ gptModal: { id, name } });
  },

  removeGPTModal() {
    set({ gptModal: null });
  },
});

export const useGPTModalStore = create<GPTModalStoreType>(store);
